import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { signoutAction } from '../user/auth/ducks/auth';
import { GnbMenu } from './GnbMenu';
import { HeaderSearch } from './HeaderSearch';
import { HeaderSearchMobile } from './HeaderSearchMobile';
import { NotificationButton } from 'app/notification/NotificationButton';

export const Header = ()=>{
    const dispatch = useDispatch();
    const {school} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useSelector(state => state.auth);
    const schoolData = useSelector(state => state.school);
    const pathname = useMemo(() => location.pathname, [location]);
    
    const [gnbCode, setGnbCode] = useState("");

    
    useEffect(() => {
        const gnbSegment = pathname.split('/')[2];
        if(gnbCode!==gnbSegment){
            setGnbCode(gnbSegment);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    useEffect(() => {
        const scrollMenu = (e)=>{
            var header = document.querySelector("#header .header_area");
            var container = document.querySelector("#container");
            if(container===null)return;
            if( window.scrollY > header.offsetHeight ){
                header.classList.add('fixed');
                container.style.marginTop = header.offsetHeight+'px';
            }else if( window.scrollY <container.offsetTop ){
                header.classList.remove('fixed');
                container.style.marginTop = 0;
            }
        };
        scrollMenu();
        window.addEventListener('scroll', scrollMenu);
        return () => window.removeEventListener('scroll', scrollMenu);
    }, []);
    

    const onMobileOpen= useCallback(()=>{
        document.querySelector("#menu_wrap").classList.add("on");
        document.querySelector("body").classList.add('fixed');
    }, []);


    const onMobileClose = useCallback(() => {
        document.querySelector("#menu_wrap").classList.remove("on");
        document.querySelector("body").classList.remove('fixed');
    }, []);

    const onLogout = useCallback(() => {
        if( !window.confirm('로그아웃 하시겠습니까?'))return;
        const result = dispatch(signoutAction());
        if(result) navigate(`/${window.schoolCode}/signin`);
        onMobileClose();
    }, [dispatch, navigate, onMobileClose]);


    return (
        <>
        <div id="header">
            <div className="header_area">
                <div className="inner">
                <h1>
                    <Link to={`/${school}/`} >
                        <p>{schoolData.cityName} {schoolData.name}</p>
                    </Link>
                </h1>
                    <HeaderSearch />
                    <div className="header_gnb">
                        <ul>
                            { auth.isAdmin==='Y' && <li className="_admin"><a href={`/${school}/manage`}>선생님</a></li>}
                            { !auth.restricted && 
                                <>
                                    <li className="_notice"><Link to={`/${school}/notice`}>공지</Link></li>
                                    <li className="_qna"><Link to={`/${school}/board/qna`}>문의</Link></li>
                                </>
                            }
                            {auth.authenticated && 
                                <>
                                    { !auth.restricted && 
                                    <>
                                        <li className="_myinfo"><Link to={`/${school}/user`} >내 정보</Link></li> 
                                        <li className="_alert"><NotificationButton onClick={onMobileClose} /></li>
                                    </>
                                    }
                                    <li className="_logout"><Link to="#" className="button logout" onClick={onLogout}>로그아웃</Link></li>
                                </>
                            }
                            { !auth.authenticated && (
                                <>
                                <li className="_login"><Link className="button login" to={`/${school}/signin`}>로그인</Link></li>
                                <li className="_login"><Link className="button login" to={`/${school}/join`}>회원가입</Link></li>
                                </>
                            )
                            }
                        </ul>
                    </div>
                    <button type="button" id="menu_open_btn" className="menu_btn" onClick={onMobileOpen}><span></span><span></span><span></span></button>
                    <button type="button" id="search_open_btn" onClick={()=>{window.$("#search_area_wrap").toggleClass("on");}}></button>
                    <HeaderSearchMobile />
                </div>
            </div>
            <div id="gnb">
                <div className="inner">
                    <GnbMenu gnbCode={gnbCode} />
                </div>
            </div>
        </div>
        <div id="menu_wrap">
            <div className="logo"><img src="/repository/logo_w.png" alt="독서길라잡이 로고" /></div>
            <button type="button" id="menu_close_btn" className="menu_btn _close" onClick={onMobileClose}><span></span><span></span><span></span></button>
            <div className="header_gnb">
                <ul>
                    { auth.isAdmin==='Y' && <li className="_admin"><a href={`/${school}/manage`}>선생님</a></li> }
                    { !auth.restricted && 
                        <>
                            <li className="_notice"><Link to={`/${school}/notice`} onClick={onMobileClose}>공지</Link></li>
                            <li className="_qna"><Link to={`/${school}/board/qna`} onClick={onMobileClose}>문의</Link></li>
                        </>
                    }   
                    
                    {auth.authenticated && 
                        <>
                            { !auth.restricted && 
                                <>
                                <li className="_myinfo"><Link to={`/${school}/user`} onClick={onMobileClose} >내 정보</Link></li>
                                <li className="_alert"><NotificationButton onClick={onMobileClose} /></li>
                                </>
                            }
                            <li className="_logout"><Link to="#" className="button logout" onClick={ onLogout }>로그아웃</Link></li>
                        </>
                    }
                    {(!auth.authenticated) && (<li className="_login"><Link className="button login" to={`/${school}/signin`} onClick={onMobileClose} >로그인</Link></li>)}
                </ul>
            </div>
            <GnbMenu gnbCode={gnbCode} onClick={onMobileClose} />
        </div>
        </>
    );
}
